import { useCallback, useEffect, useRef, useState } from 'react';

/** Copy + cờ `copied` tự tắt sau `resetMs`. */
export function useCopyToClipboard(resetMs = 1500): [boolean, (text: string) => void] {
  const [copied, setCopied] = useState(false);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  // Component có thể unmount trước khi hết hạn → setState trên node đã gỡ.
  useEffect(
    () => () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    },
    [],
  );

  const copy = useCallback(
    (text: string) => {
      void navigator.clipboard.writeText(text).then(() => {
        setCopied(true);
        if (timerRef.current) clearTimeout(timerRef.current);
        timerRef.current = setTimeout(() => {
          setCopied(false);
        }, resetMs);
      });
    },
    [resetMs],
  );

  return [copied, copy];
}
